import { cx } from 'emotion';
import { number, oneOfType, string } from 'prop-types';
import React, { useMemo } from 'react';

import { DICE_VALUE_DOTS_MAP, DOT_POSITIONING_MAP } from './constants';
import { svgClassName } from './style';

export default function Dice({ value, className, width, height, ...rest }) {
  const dots = useMemo(
    () => DICE_VALUE_DOTS_MAP[value].map((dotIndex) => (
      <circle key={dotIndex} {...DOT_POSITIONING_MAP[dotIndex]} r={3} />
    )),
    [ value ]
  );

  return (
    <svg
      className={cx(svgClassName, className)}
      viewBox="0 0 32 32"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="100%" height="100%" rx={4} />
      {dots}
    </svg>
  );
}

Dice.propTypes = {
  value: number.isRequired,
  className: string,
  width: oneOfType([ number, string ]),
  height: oneOfType([ number, string ]),
};

Dice.defaultProps = {
  width: 32,
  height: 32,
};
